import { render, staticRenderFns } from "./PermissionSubTabs.vue?vue&type=template&id=dc185446&"
import script from "./PermissionSubTabs.vue?vue&type=script&lang=js&"
export * from "./PermissionSubTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports